<template>
  <v-row dense class="mt-4" justify="space-around">
    <v-col cols="3">
      <ResumedCard
        title="Operadores Ativos"
        description="Operadores que realizaram login no período solicitado"
        :size="getAdministrativePanelData.operadores.length"
      />
    </v-col>
    <v-col cols="3">
      <ResumedCard
        title="Operadores/Ramais Avaliados"
        description="Operadores ou ramais que foram avaliados no período solicitado"
        :size="getAdministrativePanelData.avaliados.length"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'

import administrativePanelDataStore from '../_store'

import ResumedCard from './ResumedCard'

export default {
  components: { ResumedCard },
  computed: {
    ...mapGetters('administrativePanelDataStore', ['getAdministrativePanelData']),
  },

  created() {
    registerVuexModule(this.$store, 'administrativePanelDataStore', administrativePanelDataStore)
  },
}
</script>
